import React from 'react';
import HomeScreen from './HomeScreen';
import './App.css';

function App() {
    return (
        <div className="App">
            <HomeScreen/>
        </div>
    );
}

export default App;